var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpirience4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 96,
    viewBox: "0 0 97 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 96,
    height: 96,
    rx: 24,
    fill: "#EEF6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 66C49.2956 66 50.0587 65.6839 50.6213 65.1213C51.1839 64.5587 51.5 63.7956 51.5 63C51.5 62.2044 51.1839 61.4413 50.6213 60.8787C50.0587 60.3161 49.2956 60 48.5 60C47.7044 60 46.9413 60.3161 46.3787 60.8787C45.8161 61.4413 45.5 62.2044 45.5 63C45.5 63.7956 45.8161 64.5587 46.3787 65.1213C46.9413 65.6839 47.7044 66 48.5 66Z",
    fill: "#008CB7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.625 26C57.6927 26 56.125 27.4758 56.125 29.2934C56.125 31.3849 58.4583 34.6992 59.3151 35.844C59.3507 35.8923 59.3973 35.9316 59.4511 35.9588C59.505 35.9859 59.5646 36 59.625 36C59.6854 36 59.745 35.9859 59.7989 35.9588C59.8527 35.9316 59.8993 35.8923 59.9349 35.844C60.7917 34.6997 63.125 31.3866 63.125 29.2934C63.125 27.4758 61.5573 26 59.625 26Z",
    stroke: "#008CB7",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.625 60C35.6927 60 34.125 61.4758 34.125 63.2934C34.125 65.3849 36.4583 68.6992 37.3151 69.844C37.3507 69.8923 37.3973 69.9316 37.4511 69.9588C37.505 69.9859 37.5646 70 37.625 70C37.6854 70 37.745 69.9859 37.7989 69.9588C37.8527 69.9316 37.8993 69.8923 37.9349 69.844C38.7917 68.6997 41.125 65.3866 41.125 63.2934C41.125 61.4758 39.5573 60 37.625 60Z",
    stroke: "#008CB7",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.125 37C59.1242 39.5 51.625 31.5 46.1255 36C44.2922 37.6667 41.0255 42.9 42.6255 50.5C44.2255 58.1 42.1245 60 41.625 61",
    stroke: "#008CB7",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "21 21"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.125 24.5H52.125V27.5H39.125C37.7443 27.5 36.625 28.6193 36.625 30V56H33.625V30C33.625 26.9624 36.0874 24.5 39.125 24.5ZM45.125 71.5H57.625C60.6626 71.5 63.125 69.0376 63.125 66V39H60.125V66C60.125 67.3807 59.0057 68.5 57.625 68.5H45.125V71.5Z",
    fill: "#008CB7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpirience4);
export default __webpack_public_path__ + "static/media/Expirience4.8114b664b725f4b370553c02cc8ba681.svg";
export { ForwardRef as ReactComponent };